import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Providers } from './app/providers'
import { router } from './app/router'
import './i18n'
import './index.css'

// Register Background Sync with the service worker so queued mutations are
// replayed even when the user doesn't have the tab focused.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((reg) => {
    // Ask SW to schedule a sync when connectivity restores
    const syncManager = (reg as ServiceWorkerRegistration & {
      sync?: { register: (tag: string) => Promise<void> }
    }).sync
    if (syncManager) {
      syncManager.register('st-mutation-queue').catch(() => {/* optional feature */})
    }

    // Listen for SW→page drain requests (Background Sync fallback)
    navigator.serviceWorker.addEventListener('message', (e) => {
      if (e.data?.type === 'ST_DRAIN_QUEUE') {
        // Dispatch a custom event so useSyncQueue hooks can react
        window.dispatchEvent(new Event('online'))
      }
    })
  }).catch(() => {/* SW not registered in dev */})
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
